<template>
  <div>
    <v-btn small @click="dialog=!dialog" class="themed">Mettre à jour le profil</v-btn>
    <v-dialog v-model="dialog" max-width="980px">
      <v-card>
        <v-toolbar>
          <v-toolbar-title>Mettre à jour le profil</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-container fluid>
            <v-row>
              <v-col>
                <v-select
                  :items="[{value:'mr',text:'Monsieur'},{value:'mme', text:'Madame'}]"
                  placeholder="Titre"
                  hide-details="auto"
                  v-model="currentUser.title"
                  :rules="[mandatoryRules]"
                  label="Titre"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="currentUser.lastname"
                  label="Nom"
                  hide-details="auto"
                  :rules="[mandatoryRules]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="currentUser.firstname"
                  label="Prénom"
                  hide-details="auto"
                  :rules="[mandatoryRules]"
                ></v-text-field>
              </v-col>
            </v-row>
            <v-row>
              <v-col>
                <v-text-field
                  v-model="currentUser.email"
                  label="Email"
                  hide-details="auto"
                  :rules="[mandatoryRules]"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="close()" class="themed">Fermer</v-btn>
          <v-spacer></v-spacer>
          <v-btn small @click="submit()" class="primary themed">Mettre à jour</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  components: {},
  data: () => ({
    dialog: false,
    mandatoryRules: v => !!v || "Ce champ est obligatoire"
  }),
  computed: {
    ...mapGetters("auth", ["currentUser"])
  },
  methods: {
    ...mapActions("auth", ["update"]),
    submit() {
      this.update().then(() => {
        this.dialog = false;
      });
    },
    close() {
      this.dialog = false;
    },
    ...mapActions("stripes", ["sendTokenToServer"])
  }
};
</script>

<style>
</style>